// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e2bc60ae","container":"b581e013"};